import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import CoursePaymenttListLayer from "../components/CoursePaymentLayer";


const CoursePaymentListPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        {/* <Breadcrumb title="Users Grid" /> */}
        <div className="d-flex justify-content-between"><h5>Course Payments</h5><Breadcrumb title="Course Payments" /></div>
        {/* UsersListLayer */}
        <CoursePaymenttListLayer/>
  
    </>
  );
};

export default CoursePaymentListPage; 
